// ════════════════════════════════════════════════════════════════════
// Glass-i — Dispatch Plan API client (Feature 2 + 3).
// Base: /api/erp/dispatch/plans. Mirrors the dguConsumableIssueApi pattern.
// ════════════════════════════════════════════════════════════════════

import client from '../../../api/client';

const BASE = '/api/erp/dispatch/plans';
function unwrap(resp) {
  return resp && resp.data && resp.data.data !== undefined ? resp.data.data : (resp ? resp.data : null);
}
const enc = encodeURIComponent;

export const dispatchPlanApi = {
  // Candidate WOs committed to a delivery window (the plan source).
  suggest: (params = {}) => client.get(`${BASE}/suggest`, { params }).then(unwrap),
  list: (params = {}) => client.get(BASE, { params }).then(unwrap),
  get: (id) => client.get(`${BASE}/${enc(id)}`).then(unwrap),        // includes Feature-3 readiness
  create: (payload) => client.post(BASE, payload).then(unwrap),
  update: (id, payload) => client.patch(`${BASE}/${enc(id)}`, payload).then(unwrap),
  addItems: (id, workOrderIds) => client.post(`${BASE}/${enc(id)}/items`, { workOrderIds }).then(unwrap),
  removeItem: (id, itemId) => client.delete(`${BASE}/${enc(id)}/items/${enc(itemId)}`).then(unwrap),
  remove: (id) => client.delete(`${BASE}/${enc(id)}`).then(unwrap),

  // Stage DISPATCH-PLAN-2 — per-line partial dispatch.
  candidateLines: (id, workOrderId) => client.get(`${BASE}/${enc(id)}/work-orders/${enc(workOrderId)}/lines`).then(unwrap),
  addLines: (id, workOrderLineIds) => client.post(`${BASE}/${enc(id)}/lines/add`, { workOrderLineIds }).then(unwrap),
  updateItemLine: (id, lineId, payload) => client.patch(`${BASE}/${enc(id)}/lines/${enc(lineId)}`, payload).then(unwrap),
  bulkApplyLines: (id, items) => client.post(`${BASE}/${enc(id)}/lines/bulk`, { items }).then(unwrap),
  removeLine: (id, lineId) => client.delete(`${BASE}/${enc(id)}/lines/${enc(lineId)}`).then(unwrap),

  // Stage DISPATCH-PLAN-3 — vehicle arrangement per work order.
  setItemVehicle: (id, itemId, payload) => client.patch(`${BASE}/${enc(id)}/items/${enc(itemId)}/vehicle`, payload).then(unwrap),

  // Stage DISPATCH-LOADING-SLIP — printable A4 loading slip HTML (raw text/html,
  // same contract as the WO copy: no unwrap, no JSON transform).
  loadingSlip: (id) => client
    .get(`${BASE}/${enc(id)}/loading-slip`, { responseType: 'text', headers: { Accept: 'text/html' }, transformResponse: [(d) => d] })
    .then((r) => r.data),

  // Stage DISPATCH-LOADING-SLIP (PDF) — real paginated PDF as a Blob, for
  // exact, printer-safe page breaks. Returned inline; the viewer embeds +
  // prints it, and offers download.
  loadingSlipPdf: (id) => client
    .get(`${BASE}/${enc(id)}/loading-slip.pdf`, { responseType: 'blob', headers: { Accept: 'application/pdf' } })
    .then((r) => r.data)
};

export default dispatchPlanApi;
